import '../../index.css';

import { Box, CssBaseline } from '@mui/material';
import { useEffect, useState } from 'react';
import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { Icons } from '../../assets/SvgIcons';
import { RootAssets } from '../../config/rootAssets';
import {
  ComponentHelper,
  useEffectAsync,
  UserHelper,
} from '../../helper/Infra';
import {
  AiHistoryModel,
  DealProjectDTO,
  ICTask,
  MergefloDealspaceUsers,
  TemplateDTO,
} from '../../helper/Interfaces';
import { useQuery } from '../../helper/utils';
import {
  getAssetsPlaybooks,
  postAssets,
  postFunctionalAreas,
} from '../../store/feature/assetsSlice';
import {
  getPlayBookDetail,
  postUserList,
} from '../../store/feature/playBookDetailSlice';
import {
  deleteTaskHistory,
  getTaskHistory,
  selectedTaskDetailUpdate,
} from '../../store/feature/taskSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import TaskDetailModal from '../UI/TaskDetailModal/TaskDetailModal';
import Navigation from './Navigation/Navigation';
import { getUserInfo } from '@Store/feature/directory';
import MergefloInfo from '@components/UI/MergefloInfo/MergefloInfo';
import { RouteEnums } from '@Helper/Enums';
import {
  getPurePlaybook,
  getPurePlaybookList,
  postPurePlaybookList,
} from '@Store/feature/purePlaybookSlice';
import {
  getTemplateLibraryList,
  postTemplateLibraryList,
} from '@Store/feature/templateLibrarySlice';
import {
  getShowTrialEndModal,
  postShowTrialEndModal,
} from '@Store/feature/pricingSlice';
import TrialEndModal from '@components/UI/TrialEndModal/TrialEndModal';
import {
  deleteAiHistory,
  getAiHistory,
  selectedAiHistoryUpdate,
} from '@Store/feature/aiHistorySlice';
import AiModal from '@components/UI/AiModal/AiModal';

export default function LayoutContainer({ children, bodyClass }: any) {
  const [loading, setLoading] = React.useState(false);

  const [taskTray, setTaskTray] = useState<ICTask[]>([]);

  let navigate = useNavigate();
  const { id, pid } = useParams();
  const { search = '?' } = useLocation();
  let query = useQuery();
  const showTrialEndModal = useAppSelector(getShowTrialEndModal);
  const [trialEndModalPop, setTrialEndModalPop] = useState(false);
  const [showAiModal, setShowAiModal] = useState(false);

  const dispatch = useAppDispatch();
  const playBooks = useAppSelector(getAssetsPlaybooks);
  const purePlaybooks = useAppSelector(getPurePlaybookList);
  const { taskDetailHistory, isShowTaskModal, selectedTask } =
    useAppSelector(getTaskHistory);

  const { aiHistory, isShowAiHistoryModal, selectedAiHistory } =
    useAppSelector(getAiHistory);
  const [trayAiHistory, setTrayAiHistory] = useState<
    AiHistoryModel | undefined
  >(undefined);
  console.log('trayAiHistory', trayAiHistory);

  const { dealTaskList } = useAppSelector(getPlayBookDetail);

  const userInfo = useAppSelector(getUserInfo);
  const templateLibraryList = useAppSelector(getTemplateLibraryList);

  const [showInfo, setshowInfo] = useState(false);

  const [, setWorkspaceUserList] = React.useState<MergefloDealspaceUsers[]>([]);
  let userHelper = new UserHelper();
  const componentHelper = new ComponentHelper();

  useEffectAsync(async () => {
    if (localStorage.getItem('userToken') === null) {
      navigate({
        pathname: RouteEnums.Login,
        search: `${search}&to=notifications&id=${id}`,
      });
    }
    if (!playBooks || playBooks?.length < 1) {
      const haveDealspace = await userHelper.getAssets();
      if (haveDealspace.message?.includes('401')) {
        navigate({
          pathname: RouteEnums.Login,
          search: `${search}&to=notifications&id=${id}`,
        });
      }

      dispatch(postAssets(haveDealspace as RootAssets));
    }
    if (purePlaybooks === undefined) {
      const playbooks = (await componentHelper.listPlaybooks(
        id ?? ''
      )) as DealProjectDTO[];
      dispatch(postPurePlaybookList(playbooks));
    }
    if (!templateLibraryList) {
      const templateCall =
        (await componentHelper.listTemplateCollection()) as TemplateDTO[];
      dispatch(postTemplateLibraryList(templateCall));
    }
    setLoading(true);
  }, [playBooks, id]);

  useEffect(() => {
    setTrialEndModalPop(showTrialEndModal);
  }, [showTrialEndModal]);

  useEffect(() => {
    if (userInfo) {
      const skip = localStorage.getItem(userInfo?.username + 'infoSkip');
      const hasTriggered =
        userInfo?.playbookSettings &&
        userInfo?.playbookSettings[id ?? ''] &&
        userInfo?.playbookSettings[id ?? '']?.infoSkip?.infoSkip;

      if (hasTriggered === undefined && skip === null) {
        setshowInfo(true);
      } else {
        setshowInfo(false);
      }
    }
  }, [userInfo]);

  useEffectAsync(async () => {
    if (id || (pid && playBooks?.find(p => p.id === pid)?.dealspaceId)) {
      const dealspaceUserListResponse =
        await componentHelper.listDealspaceUsers(
          id ?? playBooks?.find(p => p.id === pid)?.dealspaceId ?? ''
        );

      if (dealspaceUserListResponse.length) {
        setWorkspaceUserList(
          dealspaceUserListResponse as MergefloDealspaceUsers[]
        );
        dispatch(postUserList(dealspaceUserListResponse));
      }
    }
  }, [id, pid, playBooks, purePlaybooks]);

  useEffectAsync(async () => {
    const allFunctionalAreas =
      await componentHelper.listFunctionalAreasByDealspaceId(id ?? '');
    dispatch(postFunctionalAreas(allFunctionalAreas));
  }, [id]);

  useEffect(() => {
    setTaskTray(taskDetailHistory);
  }, [taskDetailHistory]);

  const deleteTaskHistoryClick = (id: string) => {
    dispatch(deleteTaskHistory(id));
    if (selectedTask?.id === id) {
      handleTaskDetailModalClose();
    }
  };

  useEffect(() => {
    id && dispatch(getPurePlaybook(id));
  }, [id]);

  const handleTaskDetailModalClose = () => {
    const data = {
      isShowTaskModal: false,
    };
    dispatch(selectedTaskDetailUpdate(data));
  };

  const openSelectedTaskHistory = (task: ICTask) => {
    const data = {
      selectedTask: task,
      isShowTaskModal: true,
    };
    dispatch(selectedTaskDetailUpdate(data));
  };

  const openSelectedAiHistory = (aiHistory: AiHistoryModel) => {
    console.log('open');

    dispatch(
      selectedAiHistoryUpdate({
        isShowAiHistoryModal: true,
        selectedAiHistory: aiHistory,
      })
    );
    setTrayAiHistory(aiHistory);
    setShowAiModal(true);
  };

  const deleteAiHistoryClick = (id: string) => {
    dispatch(deleteAiHistory(id));
    if (selectedAiHistory?.conversationId === id) {
      handleAiHistorylModalClose();
    }
  };

  const handleAiHistorylModalClose = () => {
    dispatch(selectedAiHistoryUpdate({ isShowAiHistoryModal: false }));
  };

  useEffect(() => {
    if (query.get('selectedIssue') && dealTaskList) {
      getTaskDetail(query.get('selectedIssue') as string);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.get('selectedIssue'), dealTaskList]);

  const getTaskDetail = async (selectedIssue: string) => {
    const detailResponse = dealTaskList?.find(
      item => item.itemNumber === selectedIssue
    );

    console.log(
      'detailResponse',
      detailResponse,
      dealTaskList?.find(item => item.itemNumber === selectedIssue),
      id
    );

    if (detailResponse) {
      openSelectedTaskHistory(detailResponse);
    }
  };

  return loading ? (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Navigation />
      <Box component="main" sx={{ flexGrow: 1, backgroundColor: '#f4f5f7' }}>
        <div className="wraper">
          <div>{children}</div>
          <div className="task-detail-history">
            {taskTray?.map((task, index) => (
              <div key={index} className="task-detail-history-item">
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                  }}
                  onClick={() => openSelectedTaskHistory(task)}
                >
                  <div>{task.itemNumber}</div>
                  <div style={{ fontWeight: 600, fontSize: 12 }}>
                    {task.name && task.name.length > 15
                      ? task.name.slice(0, 15) + '...'
                      : task.name}
                  </div>
                </div>
                <div
                  className="task-tray-close"
                  onClick={() => deleteTaskHistoryClick(task.id!)}
                >
                  <Icons.Cancel />
                </div>
              </div>
            ))}
            {selectedTask && (
              <TaskDetailModal
                open={isShowTaskModal}
                onClose={handleTaskDetailModalClose}
                taskDetail={selectedTask}
              />
            )}

            {aiHistory?.map((aiHistory, index) => (
              <div key={index} className="ai-history-item">
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                  }}
                  onClick={() => openSelectedAiHistory(aiHistory)}
                >
                  <div>{aiHistory.name}</div>
                  <div style={{ fontWeight: 600, fontSize: 12 }}>
                    {aiHistory.messageHolder[0].message.length > 10
                      ? aiHistory.messageHolder[0].message.substring(0, 10)
                      : aiHistory.messageHolder[0].message}
                  </div>
                </div>
                <div
                  className="task-tray-close"
                  onClick={() => deleteAiHistoryClick(aiHistory.conversationId)}
                >
                  <Icons.Cancel />
                </div>
              </div>
            ))}
            {showAiModal && (
              <>
                <AiModal
                  openAiProps={showAiModal}
                  selectedAiModal={trayAiHistory}
                  fromLayout={true}
                  setOpenLayout={setShowAiModal}
                  setTrayAiHistory={setTrayAiHistory}
                />
              </>
            )}

            {showInfo && (
              <MergefloInfo handleClose={setshowInfo} open={showInfo} />
            )}
            {trialEndModalPop ? (
              <TrialEndModal
                showModal={trialEndModalPop}
                setShowModal={() => dispatch(postShowTrialEndModal(false))}
              />
            ) : (
              <></>
            )}
          </div>
        </div>
      </Box>
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
      />
    </Box>
  ) : (
    <></>
  );
}
